import { Link } from 'react-router-dom';
import { BrandMark } from './icons';

export default function CommercialFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="cc-footer">
      <div className="cc-wrap">
        <div className="cc-foot-grid">
          <div className="cc-foot-brand">
            <Link to="/" className="cc-brand">
              <span className="cc-brand-mark" style={{ color: 'var(--cc-gold)' }}><BrandMark /></span>
              <span className="cc-brand-name">Cloud Café <span className="cc-amp">&amp;</span> DevOps</span>
            </Link>
            <p>Treinamentos de cloud e DevOps que guiam você do estágio ao sênior — na prática, com o Pensamento de Engenheiro.</p>
          </div>

          <div className="cc-foot-col">
            <h4>Plataforma</h4>
            <Link to="/treinamentos">Entrar</Link>
            <Link to="/treinamentos/cadastro">Criar conta grátis</Link>
            <Link to="/planos">Planos</Link>
          </div>

          <div className="cc-foot-col">
            <h4>Empresa</h4>
            <Link to="/quem-somos">Quem somos</Link>
            <Link to="/objetivo">Nosso objetivo</Link>
          </div>

          <div className="cc-foot-col">
            <h4>Contato</h4>
            <a href="mailto:contato@cloudcafeedevops.io">contato@cloudcafeedevops.io</a>
            <a href="https://cloudcafeedevops.io" target="_blank" rel="noreferrer">cloudcafeedevops.io</a>
          </div>
        </div>

        <div className="cc-foot-bottom">
          <p>© {year} Cloud Café &amp; DevOps. Todos os direitos reservados.</p>
          <p className="cc-mono">feito com ☕ &amp; código</p>
        </div>
      </div>
    </footer>
  );
}
